var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistoryAlt = function SvgHistoryAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "historyAlt_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#historyAlt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5c-1.75 0-3.299-.531-4.646-1.594-1.347-1.062-2.222-2.42-2.625-4.073a.618.618 0 0 1 .125-.573.811.811 0 0 1 .563-.302.906.906 0 0 1 .604.125c.18.111.305.278.375.5a5.545 5.545 0 0 0 2.062 3.063A5.701 5.701 0 0 0 10 15.833c1.625 0 3.004-.566 4.135-1.698 1.132-1.131 1.698-2.51 1.698-4.135s-.566-3.003-1.698-4.135C13.004 4.733 11.625 4.167 10 4.167c-.958 0-1.854.222-2.688.666a6.193 6.193 0 0 0-2.104 1.834h1.459c.236 0 .434.08.593.24.16.159.24.357.24.593s-.08.434-.24.594a.806.806 0 0 1-.593.24H3.333a.806.806 0 0 1-.593-.24.806.806 0 0 1-.24-.594V4.167c0-.236.08-.434.24-.594.16-.16.357-.24.593-.24s.434.08.594.24c.16.16.24.358.24.594v1.125A7.276 7.276 0 0 1 6.76 3.229C7.781 2.743 8.861 2.5 10 2.5c1.042 0 2.017.198 2.927.594.91.396 1.702.93 2.375 1.604a7.623 7.623 0 0 1 1.604 2.375c.396.91.594 1.885.594 2.927a7.255 7.255 0 0 1-.594 2.927 7.623 7.623 0 0 1-1.604 2.375 7.623 7.623 0 0 1-2.375 1.604A7.255 7.255 0 0 1 10 17.5Zm.833-7.833 2.084 2.083a.79.79 0 0 1 .229.583.79.79 0 0 1-.23.584.79.79 0 0 1-.583.229.79.79 0 0 1-.583-.23l-2.333-2.333a.832.832 0 0 1-.25-.604V6.667c0-.236.08-.434.24-.594.159-.16.357-.24.593-.24s.434.08.594.24c.16.16.24.358.24.594v3Z",
    fill: "currentColor"
  }))));
};
export default SvgHistoryAlt;